const namespace = 'cashCoupon'

export const loadingSelector = state => {
  return state[namespace].get('fetching')
}

export const entriesSelectors = state => {
  return state[namespace].get('entries')
}

export const totalSelector = state => {
  return state[namespace].get('total')
}